const IEXEC_CHAIN_ID = 42161
const IEXEC_CHAIN_NAME = 'arbitrum-mainnet'

const WEB3MAIL_APP_ADDRESS = '0xfA9CcEfF9431Ee0E2a3Fe58911073F1357F24E31'
const WEB3MAIL_APP_WHITELIST_ADDRESS = '0xd5054a18565c4a9E5c1aa3cEB53258bd59d4c78c'
const WEB3MAIL_WORKERPOOL_ADDRESS = '0x8ef2ec3ef9535d4b4349bfec7d8b31a580e60244'

const DEFAULT_WORKERPOOL_MAX_PRICE_NRLC = 100_000_000

export {
    DEFAULT_WORKERPOOL_MAX_PRICE_NRLC,
    IEXEC_CHAIN_ID,
    IEXEC_CHAIN_NAME,
    WEB3MAIL_APP_ADDRESS,
    WEB3MAIL_APP_WHITELIST_ADDRESS,
    WEB3MAIL_WORKERPOOL_ADDRESS
}
